import React from 'react';
import './NotFound.scss';

const NotFound = () => (

  <section className="NotFound">
    <h1>Sorry, Page Not Found</h1>
  </section>

);

export default NotFound;